var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgAwardeeDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6822 100.604H18.1445V79.3957H28.6822C34.4905 79.3957 39.2198 84.1565 39.2198 90.0037C39.2198 95.8508 34.4905 100.612 28.6822 100.612V100.604ZM21.5629 97.1632H28.6822C32.6075 97.1632 35.8014 93.9479 35.8014 89.9964C35.8014 86.0448 32.6075 82.8296 28.6822 82.8296H21.5629V97.1632Z",
    fill: "#004098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8341 88.2757H67.0234V91.7169H81.8341V88.2757Z",
    fill: "url(#paint0_linear_7311_50374)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0206 100.604H76.4829C70.6746 100.604 65.9453 95.8434 65.9453 89.9963C65.9453 84.1491 70.6746 79.3883 76.4829 79.3883H87.0206V82.8295H76.4829C72.5576 82.8295 69.3637 86.0447 69.3637 89.9963C69.3637 93.9479 72.5576 97.1631 76.4829 97.1631H87.0206V100.604Z",
    fill: "#004098"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.729 100.604H141.636V97.1632H155.729C157.221 97.1632 158.438 95.9456 158.438 94.4437C158.438 92.9418 157.221 91.717 155.729 91.717H146.901C143.526 91.717 140.781 88.9538 140.781 85.5563C140.781 82.1589 143.526 79.3957 146.901 79.3957H160.995V82.8369H146.901C145.409 82.8369 144.192 84.0545 144.192 85.5563C144.192 87.0582 145.409 88.2831 146.901 88.2831H155.729C159.104 88.2831 161.849 91.0462 161.849 94.4437C161.849 97.8412 159.104 100.604 155.729 100.604Z",
    fill: "#004098"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4012 100.604H58.5048L52.7109 89.9963L55.7093 88.3413L62.4012 100.604Z",
    fill: "url(#paint1_linear_7311_50374)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9912 91.7169H42.043V79.3883H56.9912C60.3661 79.3883 63.111 82.1515 63.111 85.549C63.111 88.9464 60.3661 91.7096 56.9912 91.7096V91.7169ZM45.4614 88.2757H56.9912C58.4831 88.2757 59.6926 87.0508 59.6926 85.549C59.6926 84.0471 58.4759 82.8295 56.9912 82.8295H45.4614V88.2757Z",
    fill: "#004098"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4614 88.2757H42.043V100.604H45.4614V88.2757Z",
    fill: "#004098"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.707 93.9114L120.347 82.8514L120.289 100.604H116.871V83.0045C116.871 81.211 118.16 79.5997 119.935 79.4102C121.513 79.2425 122.947 80.1319 123.52 81.5828L127.401 91.4398L131.233 81.7213C131.74 80.4454 132.898 79.4904 134.26 79.3956C136.266 79.2643 137.939 80.8683 137.939 82.8587V100.597H134.521V82.866L130.125 93.926C129.147 96.3902 125.671 96.3902 124.7 93.9187L124.707 93.9114Z",
    fill: "#004098"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.41 91.4398L131.241 81.7213L134.529 82.8587L131.118 91.4325C130.459 93.0948 128.098 93.1386 127.432 91.4836L127.41 91.4325V91.4398Z",
    fill: "url(#paint2_linear_7311_50374)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8114 101.909C93.7178 101.909 92.6169 101.61 91.6175 100.998C90.2342 100.138 89.271 98.7889 88.9016 97.1922C88.5322 95.6028 88.793 93.9551 89.6476 92.5699L96.774 80.985C98.5412 78.1197 102.293 77.2302 105.146 79.0019C108 80.7808 108.883 84.5574 107.116 87.4299L99.9897 99.0149C98.8381 100.881 96.8465 101.909 94.8114 101.909ZM101.952 81.5172C101.062 81.5172 100.185 81.9692 99.6855 82.7858L92.559 94.3707C92.1824 94.9831 92.0665 95.6976 92.2331 96.3975C92.3997 97.0974 92.8197 97.688 93.4208 98.0598C94.0292 98.4389 94.7389 98.5556 95.4342 98.3879C96.1295 98.2275 96.7161 97.7973 97.0927 97.1922L104.219 85.6073C104.994 84.3533 104.603 82.691 103.357 81.9182C102.923 81.6484 102.438 81.5172 101.96 81.5172H101.952Z",
    fill: "#004098"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.088 101.917C108.617 101.917 108.146 101.866 107.683 101.749C106.104 101.377 104.757 100.4 103.902 99.0151L96.7757 87.4301C95.9211 86.0376 95.6532 84.3972 96.0298 82.8078C96.3991 81.2185 97.3696 79.8697 98.7457 79.0021C101.599 77.2231 105.351 78.1126 107.118 80.9852L114.244 92.5701C115.099 93.9626 115.367 95.603 114.99 97.1924C114.621 98.7818 113.65 100.138 112.274 100.998C111.304 101.603 110.203 101.917 109.088 101.917ZM101.947 81.5247C101.469 81.5247 100.984 81.6559 100.549 81.9257C99.9407 82.3048 99.5206 82.8953 99.3613 83.5952C99.1947 84.2951 99.3178 85.0096 99.6872 85.622L106.814 97.207C107.19 97.8194 107.777 98.2423 108.472 98.4027C109.167 98.5704 109.877 98.4464 110.486 98.0746C111.094 97.6955 111.514 97.1049 111.673 96.405C111.84 95.7051 111.717 94.9906 111.347 94.3782L104.221 82.7933C103.714 81.9767 102.845 81.5247 101.954 81.5247H101.947Z",
    fill: "#004098"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.088 87.4666L103.959 92.5555L101.953 89.2892L104.205 85.6147C104.785 84.6742 104.72 83.5223 104.126 82.6766C104.162 82.713 104.184 82.7568 104.213 82.7932L107.081 87.4593L107.088 87.4666Z",
    fill: "url(#paint3_linear_7311_50374)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M111.663 96.405C111.837 95.7051 111.714 94.9833 111.337 94.3782L107.086 87.4666L107.115 87.4228C108.382 85.3742 108.288 82.8589 107.086 80.9414C107.1 80.956 107.115 80.9706 107.122 80.9852L114.249 92.5774C115.103 93.9626 115.371 95.603 115.002 97.1924L111.67 96.4123L111.663 96.405Z",
    fill: "url(#paint4_linear_7311_50374)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8197 98.4683C95.0225 98.4683 95.2181 98.4537 95.4281 98.4027C96.1306 98.2423 96.71 97.8121 97.0866 97.1997L99.9401 92.5555L101.946 95.8291L99.9908 99.0078C98.8465 100.874 96.8476 101.902 94.8125 101.902V98.461L94.8197 98.4683Z",
    fill: "url(#paint5_linear_7311_50374)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7311_50374",
    x1: 81.3561,
    y1: 89.9963,
    x2: 70.6301,
    y2: 89.9963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7311_50374",
    x1: 60.0547,
    y1: 99.97,
    x2: 56.0229,
    y2: 92.5413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7311_50374",
    x1: 132.342,
    y1: 84.2804,
    x2: 128.792,
    y2: 91.2458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7311_50374",
    x1: 105.205,
    y1: 86.3292,
    x2: 102.28,
    y2: 89.5323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7311_50374",
    x1: 113.198,
    y1: 94.473,
    x2: 107.548,
    y2: 86.0066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7311_50374",
    x1: 97.0938,
    y1: 98.8401,
    x2: 100.433,
    y2: 95.4576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062375"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAwardeeDefault);
export default __webpack_public_path__ + "static/media/img-awardee-default.abfeba43fe25fb4b00846ff5a656f81d.svg";
export { ForwardRef as ReactComponent };